import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://yulmzfzxkvrmfxmumfnj.supabase.co'; // Укажите ваш Project URL
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl1bG16Znp4a3ZybWZ4bXVtZm5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3NjI3MzQsImV4cCI6MjA2NjMzODczNH0.NLZIterLYJwhOaokbxNWFXmnJUSeT9swCBkZi4kdPQ4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Store for gift images
const giftImages = {
  basic: [
    { id: 'heart', name: 'Анимированное сердце', price: 50, image: 'https://telegram.org/img/gifts/heart.gif', chance: 60 },
    { id: 'bear', name: 'Анимированный мишка', price: 50, image: 'https://telegram.org/img/gifts/bear.gif', chance: 30 },
    { id: 'star', name: 'Сверкающая звезда', price: 50, image: 'https://telegram.org/img/gifts/star.gif', chance: 10 }
  ],
  premium: [
    { id: 'crown', name: 'Корона', price: 100, image: 'https://telegram.org/img/gifts/crown.gif', chance: 50 },
    { id: 'diamond', name: 'Бриллиант', price: 100, image: 'https://telegram.org/img/gifts/diamond.gif', chance: 35 },
    { id: 'fire', name: 'Огонь', price: 100, image: 'https://telegram.org/img/gifts/fire.gif', chance: 15 }
  ],
  special: [
    { id: 'rocket', name: 'Ракета', price: 200, image: 'https://telegram.org/img/gifts/rocket.gif', chance: 40 },
    { id: 'rainbow', name: 'Радуга', price: 200, image: 'https://telegram.org/img/gifts/rainbow.gif', chance: 40 },
    { id: 'unicorn', name: 'Единорог', price: 200, image: 'https://telegram.org/img/gifts/unicorn.gif', chance: 20 }
  ]
};

// CORS headers
const corsHeaders = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Headers': 'Content-Type, Authorization',
};

// Payment Service functions
async function getUserBalance(userId) {
  try {
    const { data: user, error } = await supabase
      .from('users')
      .select('*')
      .eq('user_id', userId)
      .single();
    
    if (error && error.code !== 'PGRST116') {
      return { success: false, error: error.message };
    }
    
    if (!user) {
      return { success: false, error: 'User not found' };
    }
    
    return { 
      success: true, 
      balance: user.balance || 0,
      stars: user.stars || 0,
      ton: user.ton || 0
    };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

async function createPayment(userId, amount, currency, paymentMethod) {
  try {
    const transactionId = `tx_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    const { data: payment, error } = await supabase
      .from('payments')
      .insert({
        user_id: userId,
        amount: amount,
        currency: currency,
        payment_method: paymentMethod,
        status: 'pending',
        transaction_id: transactionId,
        created_at: new Date().toISOString()
      })
      .select()
      .single();
    
    if (error) {
      return { success: false, error: error.message };
    }
    
    return { 
      success: true, 
      transactionId: payment.transaction_id,
      payment 
    };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

async function confirmPayment(transactionId, paymentData) {
  try {
    // Получаем платеж
    const { data: payment, error: paymentError } = await supabase
      .from('payments')
      .select('*')
      .eq('transaction_id', transactionId)
      .single();
    
    if (paymentError || !payment) {
      return { success: false, error: 'Payment not found' };
    }
    
    // Обновляем статус платежа
    const { error: updateError } = await supabase
      .from('payments')
      .update({
        status: 'completed',
        confirmed_at: new Date().toISOString(),
        payment_data: paymentData
      })
      .eq('transaction_id', transactionId);
    
    if (updateError) {
      return { success: false, error: updateError.message };
    }
    
    // Обновляем баланс пользователя
    const updateField = payment.currency === 'stars' ? 'stars' : 'ton';
    const { error: balanceError } = await supabase
      .from('users')
      .upsert({
        user_id: payment.user_id,
        [updateField]: payment.amount,
        balance: 0
      }, {
        onConflict: 'user_id'
      });
    
    if (balanceError) {
      return { success: false, error: balanceError.message };
    }
    
    return { success: true, message: 'Payment confirmed' };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

async function getUserPayments(userId, limit = 10, offset = 0) {
  try {
    const { data: payments, error } = await supabase
      .from('payments')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .range(offset, offset + limit - 1);
    
    if (error) {
      return { success: false, error: error.message };
    }
    
    return { success: true, payments: payments || [] };
  } catch (error) {
    return { success: false, error: error.message };
  }
}

// Main handler
export default {
  async fetch(request, env, ctx) {
    const url = new URL(request.url);
    const path = url.pathname;
    
    // Handle CORS preflight
    if (request.method === 'OPTIONS') {
      return new Response(null, {
        status: 200,
        headers: corsHeaders
      });
    }
    
    try {
      // API Routes
      if (path === '/api/cases' && request.method === 'GET') {
        return new Response(JSON.stringify(giftImages), {
          headers: { ...corsHeaders, 'Content-Type': 'application/json' }
        });
      }
      
      if (path.startsWith('/api/user/balance/') && request.method === 'GET') {
        const userId = path.split('/').pop();
        const result = await getUserBalance(userId);
        
        return new Response(JSON.stringify(result), {
          status: result.success ? 200 : 404,
          headers: { ...corsHeaders, 'Content-Type': 'application/json' }
        });
      }
      
      if (path === '/api/payment/create' && request.method === 'POST') {
        const body = await request.json();
        const { userId, amount, currency, paymentMethod } = body;
        
        if (!userId || !amount || !currency) {
          return new Response(JSON.stringify({ 
            error: 'Missing required fields: userId, amount, currency' 
          }), {
            status: 400,
            headers: { ...corsHeaders, 'Content-Type': 'application/json' }
          });
        }
        
        const result = await createPayment(userId, amount, currency, paymentMethod);
        
        return new Response(JSON.stringify(result), {
          status: result.success ? 200 : 400,
          headers: { ...corsHeaders, 'Content-Type': 'application/json' }
        });
      }
      
      if (path === '/api/payment/confirm' && request.method === 'POST') {
        const body = await request.json();
        const { transactionId, paymentData } = body;
        
        if (!transactionId) {
          return new Response(JSON.stringify({ 
            error: 'Missing transactionId' 
          }), {
            status: 400,
            headers: { ...corsHeaders, 'Content-Type': 'application/json' }
          });
        }
        
        const result = await confirmPayment(transactionId, paymentData);
        
        return new Response(JSON.stringify(result), {
          status: result.success ? 200 : 400,
          headers: { ...corsHeaders, 'Content-Type': 'application/json' }
        });
      }
      
      if (path.startsWith('/api/user/payments/') && request.method === 'GET') {
        const userId = path.split('/').pop();
        const { limit = 10, offset = 0 } = Object.fromEntries(url.searchParams);
        const result = await getUserPayments(userId, parseInt(limit), parseInt(offset));
        
        return new Response(JSON.stringify(result), {
          status: result.success ? 200 : 400,
          headers: { ...corsHeaders, 'Content-Type': 'application/json' }
        });
      }
      
      // Default response
      return new Response(JSON.stringify({ message: 'API is running' }), {
        status: 200,
        headers: { ...corsHeaders, 'Content-Type': 'application/json' }
      });
      
    } catch (error) {
      return new Response(JSON.stringify({ error: error.message }), {
        status: 500,
        headers: { ...corsHeaders, 'Content-Type': 'application/json' }
      });
    }
  }
}; 